import * as React from 'react';
import { Card, CardContent } from '@mui/material';
import { getProductos } from '../consumos/productosficha';

export default function InformacionImg({ valueShopi, producto }) {
  // Inicializamos con un string vacío o un loader para evitar errores de renderizado inicial
  const [pdfUrl, setPdfUrl] = React.useState('');

  React.useEffect(() => {
    // 1. Verificación de existencia de datos
    const productNode = valueShopi?.data?.products?.edges?.[0]?.node;

    if (productNode) {
      // Prioridad 1: Intentar sacar la URL del metacampo que configuramos
      const urlDesdeMetafield = productNode.fichasTecnicas?.references?.edges?.[0]?.node?.url;

      if (urlDesdeMetafield) {
        setPdfUrl(urlDesdeMetafield);
      }
      // Prioridad 2: Si no hay metacampo, usar la lógica antigua de getProductos
      else {
        getProductos(producto).then((result) => {
          const nuevaUrl = `https://www.citalsa.com/cdn/shop/files/${result}.pdf`;
          setPdfUrl(nuevaUrl);
        }).catch(err => console.error("Error obteniendo producto:", err));
      }
    }
  }, [valueShopi, producto]); // Añadimos producto como dependencia por seguridad

  return (
    <Card sx={{ width: "100%", height: "1200px" }}>
      <CardContent sx={{ p: 0 }}> {/* Quitamos padding para que el iframe llene el espacio */}
        {pdfUrl ? (
          <iframe
            title="Ficha Técnica"
            style={{ width: "100%", height: "1200px", border: "none" }}
            src={pdfUrl}
          ></iframe>
        ) : (
          <p style={{ padding: '20px' }}>Cargando ficha técnica...</p>
        )}
      </CardContent>
    </Card>
  );
}